import { UIdModel } from './uid-model';

export class BuyImportRequestModal {
  public constructor() {
    this.totalPrice = 0;
    this.discount = 0;
    this.drugs = [];
    this.files = [];
  }

  public id?: string;
  public totalPrice: number;
  public drugDistributorId?: string;
  public factorId?: string;
  public factorDate?: any;
  public deliveryDate: any;
  public discount: number;

  public sellerId?: string;
  public description?: string;

  public drugs: BuyImportRequestDrugModal[];
  public files: string[];

  public DeliveryDataMessage: string | undefined;
  public factorIdMessage?: string;
  public factorDateMessage?: string;
  public totalPriceMessage?: string;
  public drugDistributorIdMessage?: string;
  public sellerIdMessage?: string;
  public preInvoiceId?: string;
}

export class BuyImportRequestDrugModal {
  public constructor(dateAdded:string) {
    this.stocks = [];
    this.lack = 0;
    this.buyDiscount = 0;
    this.buyDiscountPersent = 0;
    this.buyGift = 0;
    this.drugGenericCode = undefined;
    this.dateAdded= dateAdded;
  }

  public id?:string;
  public drugName?: string;
  public drugGenericCode?: string;
  public drugId?: string;
  public count?: number;
  public expireDate?: any;
  public shortageCount?: number;
  public lot?: string;
  public buyFactorId?: string;
  public dateAdded: string;
  public liveLack:number|undefined;

  public buyPrice?: number;
  public sellPrice?: number;
  public onlinePrice?: number;
  public partnerPrice?: number;

  public stocks: BuyImportRequestDrugStockModal[];
  public minimumDigitalCount?: number;
  public minimumCount?: number;

  public buyDiscountPersent: number;
  public buyDiscount: number;
  public buyGift: number;

  public tax?: number;

  public totalPrice?: number;
  public drugPackageCount?: number;
  public packageCount?: number;

  public lack?: number;
  public index?: number;

  public drugUIds: UIdModel[] = [];
}

export class BuyImportRequestDrugStockModal {
  public constructor() {}

  public stockId?: string;
  public stockName?: string;
  public count?: number;
}

export class BuyImportRequestValidationDrugModal {
  public constructor() {
    this.allowLowExpireDate = false;
  }

  public drugName?: string;
  public expireDate?: string;
  public count?: string;
  public totalPrice?: string;
  public sellPrice?: string;
  public buyPrice?: string;
  public drugId?: string;
  public stockId?: string;
  public stockName?: string;
  public buyDiscount?: string;
  public onlinePrice?: string;
  public partnerPrice?: string;
  public lot?: string;
  public minimumCount?: string;
  public minimumDigitalCount?: string;
  public Tax!: string;
  public allowLowExpireDate: boolean;
}

export class StockHelpItem {
  public constructor() {
    this.isActive = false;
    this.maxCount = 0;
    this.addCount = 0;
  }

  public maxCount: number;
  public addCount: number;
  public isActive: boolean;
}
type Nullable<T> = T | null;
export class BuyDrugViewModel {
  public constructor(
    source:BuyImportRequestDrugModal,
    buyFactorId:string | undefined
  ) {
    this.drugId=source.drugId??'';
    this.lOT = source.lot??'';
    this.drugName = source.drugName??'';
    this.count = source.count??0;
    this.shortageCount = (source.lack??0)*(source.drugPackageCount??1);
    this.complimentary = (source.buyGift??0)*(source.drugPackageCount??1);
    this.buyPrice = source.buyPrice??0;
    this.sellPrice = source.sellPrice??0;
    this.onlinePrice = source.onlinePrice??0;
    this.partnerPrice = source.partnerPrice??0;
    this.minimumCount = source.minimumCount??1;
    this.buyDiscount = source.buyDiscount??0;
    this.totalPrice = source.totalPrice??0;
    this.buyDiscountPercent=source.buyDiscountPersent??0;
    this.expireDate=source.expireDate??'';
    this.expireDate=source.expireDate??'';
    this.stocks=source.stocks.map((current) => ({
      count: (current.count??1) * (source.drugPackageCount??1),
      stockId: current.stockId,
      stockName: current.stockName,
    }));
    
    if(source.minimumDigitalCount==null||source.minimumDigitalCount.toString()==''){
      this.minimumDigitalCount = 1;
    }else{
      this.minimumDigitalCount = source.minimumDigitalCount;
    }

    if(source.tax==null||source.tax.toString()==''){
      this.tax = 0;
    }else{
      this.tax = source.tax;
    }

    if(buyFactorId==null||buyFactorId.toString()==''){
      this.buyFactorId = null;
    }else{
      this.buyFactorId = buyFactorId;
    }
  }
  public id: string | undefined;
  
  public buyFactorId: Nullable<string>;
  public buyDiscountPercent: number;
  public expireDate: string;
  public drugId: string;
  public lOT: string;
  public drugName: string;
  public count: number;
  public shortageCount: number;
  public complimentary: number;
  public buyPrice: number;
  public sellPrice: number;
  public onlinePrice: number;
  public partnerPrice: number;
  public minimumDigitalCount: number;
  public minimumCount: number;
  public buyDiscount: number;
  public tax: number;
  public totalPrice: number;

  public stocks:BuyImportRequestDrugStockModal[]=[];
}
